import { combineReducers } from "redux";
import room from "../features/admin/room/slice";


const stay = combineReducers({
    room: room,
});

export default stay;
